import LayoutActividad from "../../../components/LayoutActividad";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faComments } from "@fortawesome/free-solid-svg-icons";
import { modulo5 } from "../../../routes/Module5";
import Imagen1 from "../../../images/modulo5/derechoidentidad.png";
import Imagen2 from "../../../images/modulo5/dnisyndi.png";
import Imagen3 from "../../../images/modulo5/consultadni.png";

import Sidebar from "../Sidebar";
import Card from "../../../components/Card";
import GuiaDocente from "../../../components/GuiaDocente";
import AudioPlayer from "../../../audioPlayer/AudioPlayer";
import Audio from "../../../audios/modulo5/Actividad 8.mp3";

const Actividad8 = () => {
  const infoUnidad = modulo5.content[0];
  const infoAct = modulo5.content[0].activities[7];
  const crumbs = [
    {
      title: modulo5.title,
      url: "/" + modulo5.url,
    },
    {
      title:
        modulo5.content.length === 1
          ? `${infoAct.name}`
          : `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];
  const pages = {
    titleNext: `${modulo5.content[0].activities[8].name}`,
    linkNext: `${modulo5.url}/${modulo5.content[0].path}/${modulo5.content[0].activities[8].path}`,
    titlePrev: `${modulo5.content[0].activities[6].name}`,
    linkPrev: `${modulo5.url}/${modulo5.content[0].path}/${modulo5.content[0].activities[6].path}`,
  };
  const metadata = {
    color: modulo5.color,
    title: `${modulo5.title} - ${infoAct.name}`,
    name: modulo5.title,
  };

  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <p>
        <small className={`c-${modulo5.color} hat-text`}>
          <FontAwesomeIcon icon={faComments} /> Dialogamos
        </small>
      </p>

      <h2 className="mb-5">{infoAct.name}</h2>
      <AudioPlayer track={Audio} />

      <ul>
        <li>Observa las imágenes y lee los textos que las acompañan.</li>
      </ul>

      <Card>
        <div className="row align-items-center justify-content-center">
          <div className="col-md-4 col-xs-12">
            <p>
              Todos tenemos derecho a tener un nombre desde que nacemos. Se
              llama derecho a la identidad.
            </p>
          </div>
          <div className="col-md-6 col-xs-12">
            <img src={Imagen1} alt="Comic" className="img-fluid" />
          </div>
        </div>
      </Card>
      <Card>
        <div className="row align-items-center justify-content-center">
          <div className="col-md-4 col-xs-12">
            <p>
              El Documento Nacional de Identidad o DNI nos sirve para
              identificarnos y para que todos conozcan nuestro nombre.
            </p>
          </div>
          <div className="col-md-6 col-xs-12">
            <img src={Imagen2} alt="Comic" className="img-fluid" />
          </div>
        </div>
      </Card>
      <Card>
        <div className="row align-items-center justify-content-center">
          <div className="col-md-4 col-xs-12">
            <p>
              Si tenemos DNI, podemos acceder a otros derechos, como tener un
              seguro de salud.
            </p>
          </div>
          <div className="col-md-6 col-xs-12">
            <img src={Imagen3} alt="Comic" className="img-fluid" />
          </div>
        </div>
      </Card>

      <ul className="mt-5 mb-4">
        <li>
          Conversa con un compañero, compañera o familiar sobre estas preguntas
          y luego escribe las respuestas.
        </li>
      </ul>
      <div className="row">
        <div className="col-md-8 col-12">
          <p>¿Cuál es tu nombre completo?</p>
          <textarea className="form-control mb-4" rows={3} />
          <p>¿Tienes DNI?</p>
          <textarea className="form-control mb-4" rows={3} />
          <p>¿Es importante tener DNI? ¿Por qué?</p>
          <textarea className="form-control" rows={3} />
        </div>
      </div>

      <GuiaDocente>
        <p>
          Lea la primera indicación. Observen las imágenes y lean los textos.
          Pida que describan cada imagen. Luego lea la segunda indicación.
          Conversen sobre las preguntas y ayude a escribir las respuestas.{" "}
        </p>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad8;
